var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSearchCancel = function SvgSearchCancel(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.198 3.467L8.229.436a.996.996 0 0 1 1.407.002l.323.322a.998.998 0 0 1 .001 1.407L6.93 5.198 9.96 8.229a.996.996 0 0 1-.001 1.407l-.323.323a.998.998 0 0 1-1.407.001L5.198 6.93 2.167 9.96A.996.996 0 0 1 .76 9.96l-.322-.323a.998.998 0 0 1-.002-1.407l3.031-3.031L.436 2.167A.996.996 0 0 1 .438.76L.76.438A.998.998 0 0 1 2.167.436l3.031 3.031z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSearchCancel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search-cancel.3c8a2883c87bca1008f7d777e0b98a60.svg";